import { Navigate } from "react-router-dom";
import { useClientAuth } from "../contexts/ClientAuthContext";
import { Loader2 } from "lucide-react";

const ClientProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useClientAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50" data-testid="client-route-loading">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/espaceclient/login" replace />;
  }

  return children;
};

export default ClientProtectedRoute;
